const __WEBPACK_NAMESPACE_OBJECT__ = require("@noble/secp256k1");